import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-transparent py-8" data-id="element-73">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-74">
        <div className="bg-gradient-to-b from-[#1A1A1A] to-[#141414] p-8 md:p-10 rounded-2xl border border-[#2A2A2A] relative overflow-hidden" data-id="element-75">
          {/* Subtle top accent line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[2px] bg-[#C084FC]/60 rounded-full" data-id="element-76" />

          <div className="flex flex-col items-center text-center" data-id="element-77">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full bg-[#C084FC]/10 border border-[#C084FC]/20 flex items-center justify-center mb-5" data-id="element-78">
              <ShieldCheckIcon className="w-8 h-8 text-[#9333EA]" data-id="element-79" />
            </div>

            {/* Title */}
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#9333EA] font-bold mb-2" data-id="element-80">
              Compra protegida
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 font-['Open_Sans',_sans-serif]" data-id="element-81">
              Garantía de satisfacción de 7 días
            </h2>

            {/* Divider */}
            <div className="w-12 h-[1px] bg-[#2A2A2A] mb-6" data-id="element-82" />

            {/* Description */}
            <p className="text-gray-300 leading-relaxed max-w-xl mb-6 text-sm md:text-base" data-id="element-83">
              Descargá el MegaPack, revisalo, usalo en tu sala. Si en los
              próximos 7 días sentís que no es lo que esperabas, escribinos y te
              devolvemos el 100% de tu dinero.
            </p>

            {/* Trust points */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-84">
              {['Sin preguntas', 'Sin vueltas', 'Sin letra chica'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-85">
                    <CheckCircleIcon className="w-4 h-4 text-[#9333EA]" data-id="element-86" />
                    <span className="text-sm text-gray-300" data-id="element-87">{item}</span>
                  </div>)}
            </div>

            {/* Closing statement */}
            <div className="bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg px-6 py-3" data-id="element-88">
              <p className="text-sm font-semibold text-[#9333EA]" data-id="element-89">
                El riesgo es nuestro, no tuyo.
              </p>
            </div>
          </div>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4 leading-relaxed" data-id="element-90">
          La confianza que tenemos en el MegaPack Psicopedagogía nos permite
          hacer esa promesa sin dudar. Más de 300 profesionales de todo el país
          ya lo saben. La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}